module.exports = __webpack_public_path__ + "static/media/disagreed.124693db.svg";